import { Admission } from './Admission';
export class Report {
  instruction: string;
  constructor(
    public admissionInfo,
    public caseNbr,
    public dis_RequestDt_sort,
    public dob,
    public refAddr1,
    public refCity,
    public refName,
    public refState,
    public reportAllText,
    public refZip,
    public requestNbr,
    public researchInstructions,
    public researchDisplay,
    public searchFromDt,
    public searchToDt,
    public specialInstr, // flag
    public ssn,
    public jurisdiction,
    public licenseNumber,
    public specialInstructions: any = {},
    public admission,
    public admissionDisplay,
    public display,
    public applicantAdmissions: any = {}) { }

  static getWorkOrderReport(data: Report[]) {
    const rpt = new Array<Report>();

    for (const item of data) {
      rpt.push(new Report(
        item.admissionInfo,
        item.caseNbr,
        item.dis_RequestDt_sort === null ? null : new Date(item.dis_RequestDt_sort),
        item.dob !== '' ? item.dob : '',
        item.refAddr1,
        item.refCity,
        item.refName,
        item.refState,
        item.reportAllText,
        item.refZip,
        item.requestNbr,
        item.researchInstructions === null ? null : this.getSpecialInstruction(item.specialInstructions, item.reportAllText),
        item.researchDisplay = this.displaySections(item.researchInstructions),
        item.searchFromDt,
        item.searchToDt,
        item.specialInstr,
        item.ssn,
        item.jurisdiction,
        item.licenseNumber,
        item.specialInstructions,
        item.admission = Admission.getAdmissions(item.specialInstructions),
        item.admissionDisplay = this.displaySections(item.admission),
        item.display = this.display(item.admissionDisplay),
        item.applicantAdmissions
      ));
    }
    return rpt;
  }

  static getSpecialInstruction(specialInstructions: Report[], reportAllText: string): string {
    let instruction = '';

    for (const item of specialInstructions) {
      let researchInstructions = '';
      if (item.researchInstructions.length > 0) {
        for (const x of item.researchInstructions) {
          researchInstructions = x.researchInstructions;
        }
      }
      if (reportAllText !== '' && reportAllText !== undefined && reportAllText !== null) {
        if (researchInstructions !== '' && researchInstructions !== undefined && researchInstructions !== null) {
          instruction = `${reportAllText}.  ${researchInstructions}`;
        } else {
          instruction = `${reportAllText}.`;
        }
      } else {
        if (researchInstructions !== '' && researchInstructions !== undefined && researchInstructions !== null) {
          instruction = `${researchInstructions}`;
        }
      }
    }
    return instruction;
  }
  static displaySections(value: string): string {
    let display = null;
    if (value === '' || value === undefined || value === null) {
      display = 'hidden';
    }
    return display;
  }
  static display(value: string): boolean {
   if (value === 'hidden') {
      return true;
    } else {
      return false;
    }
  }
}






// WEBPACK FOOTER //
// ./src/models/report.ts